export enum ComponentSourceType {
  AssetCollection = "ASSET_COLLECTION",
  TextComponent = "TEXT_COMPONENT",
}
